import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiscardDraftIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			style: { mixBlendMode: "multiply" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1182 15.5H5.11816C4.85295 15.5 4.59859 15.3946 4.41106 15.2071C4.22352 15.0196 4.11816 14.7652 4.11816 14.5V5.5H13.1182V14.5C13.1182 14.7652 13.0128 15.0196 12.8253 15.2071C12.6377 15.3946 12.3834 15.5 12.1182 15.5Z",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.11816 12.5V8.5",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1182 12.5V8.5",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.61816 4.14139L14.3342 1.43872",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.02765 0.521976L6.09432 1.14531C5.96556 1.17248 5.84344 1.22479 5.73494 1.29925C5.62645 1.3737 5.53371 1.46884 5.46206 1.57921C5.3904 1.68957 5.34123 1.81299 5.31737 1.9424C5.2935 2.0718 5.29541 2.20464 5.32298 2.33331L5.53365 3.30998L10.4243 2.26998L10.2136 1.29198C10.1585 1.03261 10.0025 0.805789 9.78009 0.661392C9.55768 0.516994 9.28703 0.466846 9.02765 0.521976V0.521976Z",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgDiscardDraftIcon);
export default ForwardRef;
